module.exports = __webpack_public_path__ + "static/media/SkyengLogo.c09a09c0.jpg";